import { writable } from "svelte/store";

export const datagridStore = writable({});
export const datagridFilterStore = writable({
  get: {
    id: 0,
    type: "",
    tab: "",
  },
  post: {
    search: "",
    layer: {},
    pagination: {
      start: 0,
      limit: 50,
    },
    order: {
      column: 0,
      type: "asc",
    },
  },
});
export const datagridHistoryStore = writable({ data: [], active: 0 });
